module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vwassets/new2/_next/static/images/pdp_squareHover-44fa1c55aea0e71995c9a0e2072982cb.jpg";